import React, { useEffect } from 'react';
import { Global, css } from '@emotion/react';

import { setShowLearnerTakeaway } from 'redux/actions/learner-final-summary';
import { useAppDispatch } from 'redux/store';
import LearnerTakeawayTakeover from './learner-takeaway';

const takeawayPagePrintStyles = css`
  @media print {
    html,
    body,
    #main-panel,
    .main-content-wrapper,
    #main-content,
    #main-content > div,
    .my-take-away-main {
      height: auto !important;
      min-height: 0 !important;
      overflow: visible !important;
      max-height: none !important;
    }

    #main-panel,
    .main-content-wrapper,
    #main-content,
    #main-content > div {
      position: static !important;
      inset: auto !important;
    }

    #top-nav,
    nv-l1-course-header,
    .nav.left-nav,
    .right-nav,
    .mobile-nav,
    .reconnecting-banner,
    nv-mentees-button,
    .ask-novoai-button {
      display: none !important;
    }

    #main-content.my-take-away-main {
      margin: 0 !important;
      padding: 0 !important;
      width: 100% !important;
    }
  }
`;

const MyTakeAwayPage = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setShowLearnerTakeaway(true));
    return () => {
      dispatch(setShowLearnerTakeaway(false));
    };
  }, [dispatch]);

  return (
    <>
      <Global styles={takeawayPagePrintStyles} />
      <LearnerTakeawayTakeover />
    </>
  );
};

export default MyTakeAwayPage;
